import { useEffect, useRef } from "react";

const isCtrlSpace = (e) => e.ctrlKey && e.code === "Space";

/**
 * Ctrl+Space while `enabled`: runs `onCtrlSpace` (if given) once per press, and never lets the key reach the
 * focused control (e.g. the NF switch, which toggles on Space): not on press, while it repeats, or on release
 * (Space pressed just before Ctrl). A released Ctrl followed by a space does nothing.
 */
const useCtrlSpaceShortcut = (onCtrlSpace, enabled = true) => {
  const handlerRef = useRef(onCtrlSpace);
  handlerRef.current = onCtrlSpace;

  useEffect(() => {
    if (!enabled) return undefined;

    const handleKeyDown = (e) => {
      if (!isCtrlSpace(e)) return;

      e.preventDefault();
      if (!e.repeat) handlerRef.current?.();
    };

    const handleKeyUp = (e) => {
      if (isCtrlSpace(e)) e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [enabled]);
};

export default useCtrlSpaceShortcut;
